import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { open_contact } from "../redux/features/chat/chatSlice";
import {
	getLoginStatus, getUser, selectIsLoggedIn, selectUser,
} from "../redux/features/auth/authSlice";
import SocketContext from "../context/SocketContext";
import axios from "axios";

export const shortenText = (text, n) => {
	if (text?.length > n) {
		const shoretenedText = text.substring(0, n).concat("...");
		return shoretenedText;
	}
	return text;
};

const Contact = ({ contact, setSearchResults, socket, isDisabled }) => {

	const dispatch = useDispatch();
	const [locationMappings, setLocationMappings] = React.useState({});
	// const { user } = useSelector((state) => state.auth);
	//  	const {token} = user;
	const values = {
		receiver_id: contact._id,
		// user:user.token,
	};
	const isLoggedIn = useSelector(selectIsLoggedIn);
	const user = useSelector(selectUser);
	// useEffect(() => {
	//     dispatch(getLoginStatus());
	//     if (isLoggedIn && user === null) {
	//       dispatch(getUser());
	//     }

	// }, [dispatch, isLoggedIn, user]);
	// alert(contact.email);

	// Fetch location mappings on mount
	useEffect(() => {
		fetchLocationMappings();
	}, []);

	const fetchLocationMappings = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/users/location-mappings`,
				{ withCredentials: true }
			);
			setLocationMappings(response.data.emailToConversationType || {});
		} catch (error) {
			console.error('Error fetching location mappings:', error);
		}
	};

	const openConversation = async (name) => {
		let newChat = await dispatch(open_contact(values));
		socket.emit("join conversation", newChat.payload._id);
		// console.log(newChat.payload._id);
		// dispatch(open_create_conversation(values));
		setSearchResults([]);

		// Use dynamic location mapping instead of hardcoded if/else
		const conversationType = locationMappings[contact.email] ||
			locationMappings[user.email] ||
			'support';

		// console.log(conversationType)

		//   try {
		//     const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/conversation/${newChat.payload._id}`, {
		//         method: 'PATCH',
		//         headers: {
		//             'Content-Type': 'application/json',
		//         },
		//         body: JSON.stringify({ conversationType: 'conversationType' }),
		//     });
		//     console.log(response);
		//     if (!response.ok) {
		//         throw new Error('Failed to save type');
		//     }

		//     console.log('Type saved successfully');
		// } catch (error) {
		//     console.error('Error saving type:', error.message);
		// }
		try {
			const config = {
				headers: {
					"Content-type": "application/json",
				},
			};
			const { data } = await axios.patch(
				`${process.env.REACT_APP_BACKEND_URL}/api/conversation/${newChat.payload._id}`,
				{
					conversationType: conversationType,
				},
				config
			);
			// console.log(data);
		} catch (error) {
			console.error("Error saving type");
		}
	};
	const { shiftBookings } = useSelector((state) => state.auth);
	const isStudent = user?.type === 'student';

	// Determine shifts to display
	let shiftsToDisplay = contact.shiftBookingShifts || [];
	if (isStudent && shiftBookings) {
		const bookedShiftIds = new Set();
		shiftBookings.forEach(bookingData => {
			bookingData.bookings?.forEach(booking => {
				if (booking.student?.toString() === user._id?.toString() && booking.status === 'Active') {
					bookedShiftIds.add(booking.shift.toString());
				}
			});
		});

		shiftsToDisplay = shiftsToDisplay.filter(shift =>
			bookedShiftIds.has(shift._id?.toString() || shift.toString())
		);
	}

	return (
		<>
			<li className={isDisabled ? 'disabledUser' : 'card'} style={{ margin: '5px' }} onClick={() => openConversation(contact.name)}>
				<div className="chatImg">
					<img src={contact.picture} alt={contact.name} />
				</div>
				<div className="chatDetail">
					<h6>{shortenText(contact.displayName || contact.name)}</h6>
					<p>{contact.email}</p>
					{shiftsToDisplay.length > 0 && (
						<div className="shift-info" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
							{/* {shiftsToDisplay.map((shift, index) => (
								<div key={index} className="shift-time">
									🕒 {shift.startTime} - {shift.endTime}
								</div>
							))} */}
						</div>
					)}
				</div>
			</li>
		</>
	)
}

const ContactWithContext = (props) => (
	<SocketContext.Consumer>
		{(socket) => <Contact {...props} socket={socket} />}
	</SocketContext.Consumer>
);

export default ContactWithContext